var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChevronDoubleLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0.333313H6.5L3.16667 4.99998L6.5 9.66665H3.5L0.166667 4.99998L3.5 0.333313Z",
    fill: "#959595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1665 0.333313H11.1665L7.83317 4.99998L11.1665 9.66665H8.1665L4.83317 4.99998L8.1665 0.333313Z",
    fill: "#959595"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDoubleLeft);
export default __webpack_public_path__ + "static/media/icon_chevron-double-left.2951954c0e95cd72d415f53498c280cd.svg";
export { ForwardRef as ReactComponent };